import { render, staticRenderFns } from "./UpdateCollectionDialog.vue?vue&type=template&id=92503cca&scoped=true"
import script from "./UpdateCollectionDialog.vue?vue&type=script&lang=js"
export * from "./UpdateCollectionDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateCollectionDialog.vue?vue&type=style&index=0&id=92503cca&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92503cca",
  null
  
)

export default component.exports